import * as React from 'react';
import { Dict } from '../../core/models';
import AccordionSection from './AccordionSection';

interface CustomProps {
  allowMultipleOpen?: boolean;
  defaultId: string;
  closeAll?: boolean;
  onAccordionClick?: () => void;
}

export const Accordion: React.FunctionComponent<CustomProps> = (props) => {
  const [openSections, setOpenSections] = React.useState<Dict<boolean>>({
    [props.defaultId]: true,
  });

  const [loaded, setLoaded] = React.useState<boolean>(false);

  React.Children.forEach(props.children, (child) => {
    if (React.isValidElement(child)) {
      if (child.props.isOpen) {
        openSections[child.props.id] = true;
      }
    }
  });

  React.useEffect(() => {
    if (props.defaultId) {
      setOpenSections({
        [props.defaultId]: true,
      });
    }
    setLoaded(true);
  }, [props.defaultId]);

  React.useEffect(() => {
    if (props.closeAll) {
      setOpenSections(
        !loaded
          ? {
              [props.defaultId]: true,
            }
          : {}
      );
    }
    setLoaded(true);
  }, [props.closeAll]);

  const onClick = (id: any) => {
    const isOpen = !!openSections[id];
    if (props.allowMultipleOpen) {
      setOpenSections({
        ...openSections,
        [id]: !isOpen,
      });
    } else {
      setOpenSections({
        [id]: !isOpen,
      });
    }
    props.onAccordionClick?.();
  };

  return (
    <div>
      {React.Children.map(props.children, (child) => (
        <>
          {React.isValidElement(child) ? (
            <AccordionSection
              isOpen={!!openSections[child.props.id]}
              label={child.props.id}
              onClick={onClick}
              title={child.props.title}
              className={child.props.className}
            >
              {child.props.children}
            </AccordionSection>
          ) : (
            child
          )}
        </>
      ))}
    </div>
  );
};

export default Accordion;
